import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import EventDetailPage from "@/pages/EventDetailPage";

export const Route = createFileRoute("/en/events/$slug")({
  loader: ({ params }) => loadContentMeta("events", params.slug, "en"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/en/events/${params.slug}`, loaderData),
  component: EventDetailPage,
});

